import { UHttp } from "../../utils/UHttp";

const apiUrlServer = process.env.REACT_APP_URL_SERVER;

/**
 * Interface pour la réponse de validation de code promo
 */
export interface PromoCodeValidationResult {
  isValid: boolean;
  discountAmount: number;
  finalAmount: number;
  message?: string;
  promoCodeId?: string;
}

/**
 * Interface pour la réponse de l'API
 */
interface ApiResponse<T = any> {
  success: boolean;
  message?: string;
  data?: T;
}

/**
 * Modèle pour gérer les codes promo côté client
 */
class ClientPromoCodeModel {
  private static instance: ClientPromoCodeModel;

  private constructor() {}

  /**
   * Récupère l'instance unique du modèle (singleton)
   */
  public static getInstance(): ClientPromoCodeModel {
    if (!ClientPromoCodeModel.instance) {
      ClientPromoCodeModel.instance = new ClientPromoCodeModel();
    }
    return ClientPromoCodeModel.instance;
  }

  /**
   * Valide un code promo pour un client
   */
  async validatePromoCode(params: {
    code: string;
    clientId: string;
    companyId: string;
    amount: number;
    serviceId: string;
  }): Promise<ApiResponse<PromoCodeValidationResult>> {
    try {
      const response = await UHttp.post(
        `${apiUrlServer}/public-api/promo-code/validate`,
        params,
        UHttp.publicApiHeaders()
      );

      if (!response.ok) {
        const errorData = await response.json();
        return {
          success: false,
          message: errorData.message || 'Erreur lors de la validation du code promo',
        };
      }

      const data = await response.json();

      if (data.success && data.data) {
        return {
          success: true,
          data: data.data,
        };
      } else {
        return {
          success: false,
          message: data.message || 'Code promo invalide',
        };
      }
    } catch (error: any) {
      console.error('Error validating promo code:', error);
      return {
        success: false,
        message: error.message || 'Erreur réseau',
      };
    }
  }
}

export default ClientPromoCodeModel;